import * as React from 'react';
import { styled } from '@linaria/react';

import { Wrapper, Label } from './EquationMask.helpers';

function EquationMaskIntro() {
  return (
    <Wrapper>
      <Column>
        <Label>Element</Label>
        <Initial src="/images/backdrop-filter/tokyo.jpg" />
      </Column>
      <Symbol>+</Symbol>
      <Column>
        <Label>Mask</Label>

        <Squares />
        <Mask src="/images/backdrop-filter/tokyo-mask.png" />
      </Column>
      <Symbol>=</Symbol>
      <Column>
        <Label>Result</Label>

        <Squares />
        <Img src="/images/backdrop-filter/tokyo-masked.png" />
      </Column>
    </Wrapper>
  );
}

const Column = styled.div`
  position: relative;
  width: 200px;
  min-width: 0;
  aspect-ratio: 1 / 1;
  outline: 1px solid var(--color-gray-300);
`;

const Initial = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Img = styled.img`
  position: relative;
  width: 200px;
  aspect-ratio: 1 / 1;
`;

const Symbol = styled.div`
  width: 5rem;
  height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 4rem;
  font-family: var(--font-family-mono);
`;

const Squares = styled.div`
  position: absolute;
  inset: 0;
  opacity: 0.4;
  background-image: url('/images/backdrop-filter/transparent-squares.png');
  background-size: 20px 20px;
  transition: opacity var(--color-swap-duration);

  html[data-color-mode='dark'] & {
    opacity: 0.2;
  }
`;

const Mask = styled(Img)`
  html[data-color-mode='dark'] & {
    filter: invert(1);
  }
`;

export default EquationMaskIntro;
